import { ComponentChildren } from 'preact'

export interface PostMetadataProps {
  publishedAt?: string
  children?: ComponentChildren
}

const PostMetadata = ({ publishedAt, children }: PostMetadataProps) => {
  return (
    <header className='clearfix'>
      <span className='text-muted post--time'>
        Posted on {publishedAt}
      </span>
      <div className='pull-right'>
        {children}
      </div>
    </header>
  )
}

export default PostMetadata
